import React from "react";
import { apiPath } from "../utilities/Constants";
import useFetch from "../hooks/useFetch";
import GlobalForm from "../components/globalForm/GlobalForm";
import { updateData } from "../hooks/update";
import Loader from "../components/shared/Loader/Loader";
import LoaderFilling from "../components/shared/Loader/LoaderFilling";

function PlatformPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { logo, logoColor, heroTitle, heroSlogan, heroImg, _id } =
    apiData[0] ?? {};

  // Form data
  const data = [
    {
      elementType: "heading",
      label: `Logo Section`,
      name: "heading",
      type: "heading",
      firstElement: true,
    },
    {
      elementType: "file",
      label: `Colored logo`,
      name: "logoColor",
      type: "file",
      fullCol: true,
      defaultValue: { url: logoColor },
      required: false,
    },
    {
      elementType: "file",
      label: `BW Logo`,
      name: "logo",
      type: "file",
      fullCol: true,
      defaultValue: { url: logo },
      required: false,
    },
    {
      elementType: "heading",
      label: `Hero Section`,
      name: "heading",
      type: "heading",
    },
    {
      elementType: "input",
      label: "Hero title",
      type: "Text",
      name: "heroTitle",
      defaultValue: heroTitle,
      required: false,
      info: "Separate with </br>",
    },
    {
      elementType: "textField",
      label: "hero slogan",
      type: "Text",
      name: "heroSlogan",
      defaultValue: heroSlogan,
      required: false,
    },
    {
      elementType: "file",
      label: "hero image",
      type: "file",
      name: "heroImg",
      defaultValue: heroImg && heroImg[0],
      required: false,
      fullCol: true,
    },
  ];

  const update = (data) => {
    data.heroImg = heroImg;
    delete data.heading;
    updateData(homeApi, data, _id);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default PlatformPage;
